// Oncall's widgets on the Dashboard and the Marketing page (#253). Registered
// from `./index` at bootstrap; consumers render them by id and do not import
// Oncall. Contract: `src/lib/dashboard-widgets.tsx`. Registrations only.
import { registerDashboardWidget } from '@/lib/dashboard-widgets'

registerDashboardWidget({
    id: 'oncall.timeline',
    load: () => import('./components/DashboardWidgets/OncallTimelineWidget'),
})
registerDashboardWidget({
    id: 'oncall.sales-schedule',
    load: () =>
        import('./components/DashboardWidgets/SalesOncallScheduleWidget'),
})
// Bare timeline (props: { departmentId }) for hosts that compose their own card.
registerDashboardWidget({
    id: 'oncall.department-timeline',
    load: () =>
        import(
            './components/Assignments/Timeline/components/DashboardTimeline'
        ),
})
